import { render, staticRenderFns } from "./ThgFrequentlyAskedQuestionsAt.vue?vue&type=template&id=7ddf07b4&scoped=true"
import script from "./ThgFrequentlyAskedQuestionsAt.vue?vue&type=script&lang=ts"
export * from "./ThgFrequentlyAskedQuestionsAt.vue?vue&type=script&lang=ts"
import style0 from "./ThgFrequentlyAskedQuestionsAt.vue?vue&type=style&index=0&id=7ddf07b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf07b4",
  null
  
)

export default component.exports